import { MailWarningIcon } from 'lucide-react';
import React, { useState } from 'react';

const FaqToggle = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqData = [
    {
      question: ' What can I do with Maamaas?',
      answer:
        "Everything! Order food, book rides, shop essentials, reserve rooms, schedule services, and more – all from your mobile",
    },
    {
      question: 'How is Maamaas different?',
      answer: 'We charge no commission from vendors. That means you pay fair prices, support local businesses, and enjoy full transparency.',
    },
    {
      question: "Are there any extra charges?",
      answer: "Only a small platform fee per booking – shown before you pay. No surprise costs. No hidden charges.",
    },
    {
      question: 'Can I use Maamaas in multiple cities?',
      answer: 'Yes, Maamaas is expanding rapidly. Use your account wherever our network is active – with one simple login.',
    },
    {
      question: "What if I need help with an order?",
      answer: 'Tap the Help section in the app for instant chat or call support. We’re always here for you.',
    },

  ];

  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div style={styles.container}>
     <h2 className='faqsmamaas' style={{ textAlign: 'center', fontSize: '50px',fontWeight:'bold', }}>
  <span style={{ color: 'gold' }}>USER </span>
  <span style={{ color: 'white' }}>FAQs</span>
  <span style={{ color: 'gold' }}> – Know Before You Tap</span>
</h2>
      {faqData.map((item, index) => (
        <div key={index} style={styles.card}>
          <div style={styles.questionRow} onClick={() => toggleFAQ(index)}>
            <p style={styles.question}>{item.question}</p>
            <span style={styles.icon}>{activeIndex === index ? '▲' : '▼'}</span>
          </div>
          {activeIndex === index && (
            <div style={styles.answer}>
              <p>{item.answer}</p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

// Inline CSS (internal styling)
const styles = {
  container: {
    // maxWidth: '1357px',
    margin: 'auto',
    padding: '20px',
    fontFamily: 'Arial, sans-serif',
    backgroundColor:'#2a0947',
    marginTop:'30px'
  },
  title: {
    textAlign: 'center',
    marginBottom: '20px',
    fontSize: '50px',
    fontWeight:'bold',
   
  },
  card: {
    backgroundColor: '#f3f6fb',
    marginBottom: '10px',
    borderRadius: '8px',
    padding: '10px 15px',
    boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
  },
  questionRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
  },
  question: {
    fontWeight: 'bold',
    fontSize: '16px',
    margin: '0',
  },
  icon: {
    fontSize: '20px',
    color: '#555',
  },
  answer: {
    marginTop: '10px',
    fontSize: '15px',
    color: '#444',
  },
};

export default FaqToggle;
